import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TBackgroundV2, IBgDeps } from './models';
import { BackgroundV2 as Component } from './components/background';
import styles from './styles/styles.css';

export const BackgroundV2 = createWidget<IBgDeps, TBackgroundV2>({ styles })(Component);
